import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import Reveal from "../shared/Reveal";

const AREAS = [
  { label: "Dundalk", slug: "dundalk" },
  { label: "Essex", slug: "essex" },
  { label: "Towson", slug: "towson" },
  { label: "Catonsville", slug: "catonsville" },
  { label: "Parkville", slug: "parkville" },
  { label: "Middle River", slug: "middle-river" },
  { label: "Rosedale", slug: "rosedale" },
  { label: "Owings Mills", slug: "owings-mills" },
  { label: "White Marsh", slug: "white-marsh" },
  { label: "Perry Hall", slug: "perry-hall" },
  { label: "Pikesville", slug: "pikesville" },
  { label: "Reisterstown", slug: "reisterstown" },
  { label: "Cockeysville", slug: "cockeysville" },
  { label: "Severna Park", slug: "severna-park" },
  { label: "Columbia", slug: "columbia" },
  { label: "Annapolis", slug: "annapolis" },
];

export default function ServiceAreasPreview() {
  return (
    <section className="py-20 lg:py-24 bg-secondary/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="font-body text-accent text-sm font-semibold uppercase tracking-[0.18em] mb-3">Where We Work</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground mb-4">
            Serving Greater Baltimore
          </h2>
          <p className="font-body text-muted-foreground text-base">
            Based in Dundalk — we serve a 20-mile radius across Baltimore City, Baltimore County, and surrounding areas.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-3">
          {AREAS.map((area, i) => (
            <Reveal
              key={area.slug}
              y={10}
              delay={i * 30}
            >
              <Link
                to={`/areas/${area.slug}`}
                className="flex items-center gap-2 px-4 py-3 bg-card rounded-lg border border-border hover:border-accent/40 hover:shadow-sm hover:text-accent transition-all font-body text-sm text-foreground group"
              >
                <MapPin className="w-3.5 h-3.5 text-accent flex-shrink-0" />
                {area.label}, MD
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}